import type { AdminTeam } from '@gg/shared';

/**
 * "2 / 4 payés · 3 minimum", "2 / 2 payés" (fixed size) or "3 payés · 2 minimum" (unlimited),
 * plus the pending invitations.
 */
export function teamMembersLabel(
  t: (k: string, o?: Record<string, unknown>) => string,
  team: AdminTeam,
) {
  const { joined, sizeMin: min, sizeMax: max } = team;
  const paid =
    max === null
      ? t('admin.teams.membersOpen', { joined, min })
      : max === min
        ? t('admin.teams.members', { joined, max })
        : t('admin.teams.membersRange', { joined, min, max });
  return team.invited ? `${paid} · ${t('admin.teams.pending', { count: team.invited })}` : paid;
}
